import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../../helpers/JsonMapper";
import CustomShippingData from "./CustomShippingData";
import CustomReviewsData from "./CustomReviewsData";
import CheckoutFormSettings from "../FormSettings/CheckoutFormSettings";
import GeneralData from "./GeneralData";
var _attributes = /*#__PURE__*/new WeakMap();
export default class CheckoutData extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [CheckoutData.general_attribute_name]: GeneralData,
      [CheckoutData.shipping_attribute_name]: CustomShippingData,
      [CheckoutData.reviews_attribute_name]: CustomReviewsData,
      [CheckoutData.checkout_form_settings_attribute_name]: CheckoutFormSettings
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getGeneralAttributeName() {
    return CheckoutData.general_attribute_name;
  }
  static getShippingAttributeName() {
    return CheckoutData.shipping_attribute_name;
  }
  static getReviewsAttributeName() {
    return CheckoutData.reviews_attribute_name;
  }
  static getCheckoutFormSettingsAttributeName() {
    return CheckoutData.checkout_form_settings_attribute_name;
  }
  getGeneral() {
    return this.getAttribute(CheckoutData.general_attribute_name);
  }
  getShippingData() {
    return this.getAttribute(CheckoutData.shipping_attribute_name);
  }
  getReviewsData() {
    return this.getAttribute(CheckoutData.reviews_attribute_name);
  }
  getCheckoutFormSettingsData() {
    return this.getAttribute(CheckoutData.checkout_form_settings_attribute_name);
  }
  getPaymentMethod() {
    let checkoutFormSettings = this.getCheckoutFormSettingsData();
    return checkoutFormSettings instanceof CheckoutFormSettings ? checkoutFormSettings.getPaymentMethod() : null;
  }
  getShortProductName() {
    const generalData = this.getGeneral();
    return generalData instanceof GeneralData ? generalData.getShortProductName() : null;
  }
}
_defineProperty(CheckoutData, "general_attribute_name", 'general');
_defineProperty(CheckoutData, "shipping_attribute_name", 'shipping');
_defineProperty(CheckoutData, "reviews_attribute_name", 'reviews');
_defineProperty(CheckoutData, "checkout_form_settings_attribute_name", 'form_settings');